import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Timeline(theme: Theme, containerId: string) {
  return {
    MuiTimelineDot: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },

    MuiTimelineConnector: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.divider,
        },
      },
    },
  };
}
